export default __webpack_public_path__ + "static/media/480_dummy2016-pragentur01-de.797e3ae4.png";